/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationPaymentBillingInfoResponseData,
  GetOrganizationPaymentBillingInfoResponseDataFromJSON,
  GetOrganizationPaymentBillingInfoResponseDataFromJSONTyped,
  GetOrganizationPaymentBillingInfoResponseDataToJSON
} from './GetOrganizationPaymentBillingInfoResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationPaymentPlanPaidResponse
 */
export interface UpdateOrganizationPaymentPlanPaidResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationPaymentPlanPaidResponse
   */
  status: number
  /**
   *
   * @type {GetOrganizationPaymentBillingInfoResponseData}
   * @memberof UpdateOrganizationPaymentPlanPaidResponse
   */
  data: GetOrganizationPaymentBillingInfoResponseData
}

export function UpdateOrganizationPaymentPlanPaidResponseFromJSON(
  json: any
): UpdateOrganizationPaymentPlanPaidResponse {
  return UpdateOrganizationPaymentPlanPaidResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationPaymentPlanPaidResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationPaymentPlanPaidResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOrganizationPaymentBillingInfoResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationPaymentPlanPaidResponseToJSON(
  value?: UpdateOrganizationPaymentPlanPaidResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationPaymentBillingInfoResponseDataToJSON(value.data)
  }
}
